// Guardian relationships, shared by registration, the patient's file, the Issue Token dialog,
// the queue and the printed token slip. Values match the backend enum; labels are user-facing.
// Alphabetical by label; OTHER pinned to the end.
export const GUARDIAN_RELATIONSHIPS = [
  { value: 'AUNT',        label: 'Aunt' },
  { value: 'BROTHER',     label: 'Brother' },
  { value: 'FATHER',      label: 'Father' },
  { value: 'GRANDFATHER', label: 'Grandfather' },
  { value: 'GRANDMOTHER', label: 'Grandmother' },
  { value: 'GUARDIAN',    label: 'Legal Guardian' },
  { value: 'MOTHER',      label: 'Mother' },
  { value: 'SISTER',      label: 'Sister' },
  { value: 'UNCLE',       label: 'Uncle' },
  { value: 'OTHER',       label: 'Other' },
];

// The user-facing relationship label. For OTHER, prefers the free text the user typed so the
// record reads "Step-father" rather than "Other".
export const guardianRelLabel = (value, otherText) => {
  if (value === 'OTHER' && otherText && otherText.trim()) return otherText.trim();
  return GUARDIAN_RELATIONSHIPS.find(r => r.value === value)?.label || value;
};

// "Fatima Bibi (Mother)": how an adult on a child's file is named wherever one is listed or
// picked. Works for a guardian row and for the snapshot a visit carries, which share field names.
export const describeGuardian = (g) => {
  if (!g || !g.name) return '';
  const rel = g.relationship ? guardianRelLabel(g.relationship, g.relationshipOther) : '';
  return rel ? `${g.name} (${rel})` : g.name;
};
